import { render, staticRenderFns } from "./AddInbox.vue?vue&type=template&id=352a4b1a&scoped=true&"
import script from "./AddInbox.vue?vue&type=script&lang=js&"
export * from "./AddInbox.vue?vue&type=script&lang=js&"
import style0 from "./AddInbox.vue?vue&type=style&index=0&id=352a4b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a4b1a",
  null
  
)

component.options.__file = "AddInbox.vue"
export default component.exports